var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvolveLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1829",
    "data-name": "Group 1829",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.724,
    height: 21.818,
    viewBox: "0 0 60.724 21.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M649.906,399.136",
    transform: "translate(-606.955 -391.541)",
    fill: "#a4bac6",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M672.427,399.136",
    transform: "translate(-626.054 -391.541)",
    fill: "#a4bac6",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827",
    transform: "translate(18.223 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    transform: "translate(0.451 0.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.369,
    cy: 0.369,
    r: 0.369,
    transform: "translate(9.878 13.049)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.179,
    cy: 0.179,
    r: 0.179,
    transform: "translate(5.791 14.172) rotate(-63.136)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M502.525,428.348a.295.295,0,1,1-.371-.189A.295.295,0,0,1,502.525,428.348Z",
    transform: "translate(-500.157 -416.45)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M490.5,404.83a.179.179,0,1,1-.225-.115A.179.179,0,0,1,490.5,404.83Z",
    transform: "translate(-490.151 -396.574)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.295,
    cy: 0.295,
    r: 0.295,
    transform: "translate(0.554 3.783)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M514.2,357.344a.179.179,0,1,1-.225-.115A.178.178,0,0,1,514.2,357.344Z",
    transform: "translate(-510.25 -356.304)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.179,
    cy: 0.179,
    r: 0.179,
    transform: "translate(11.747 2.104)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.295,
    cy: 0.295,
    r: 0.295,
    transform: "translate(7.857)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.295,
    cy: 0.295,
    r: 0.295,
    transform: "translate(13.713 5.839)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.179,
    cy: 0.179,
    r: 0.179,
    transform: "translate(13.099 10.172)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596",
    transform: "translate(0.578 1.19)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 0.357,
    cy: 0.357,
    r: 0.357,
    transform: "matrix(0.63, -0.776, 0.776, 0.63, 6.026, 5.967)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(8.94 7.454)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(5.446 9.208)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "matrix(0.248, -0.969, 0.969, 0.248, 3.35, 6.529)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "matrix(0.28, -0.96, 0.96, 0.28, 5.802, 2.34)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(9.739 3.206)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(11.536 5.945)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(11.241 7.899)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(10.502 9.951)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M547.7,434.537a.177.177,0,1,1-.223-.114A.177.177,0,0,1,547.7,434.537Z",
    transform: "translate(-539.241 -422.957)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M532.783,433.349a.177.177,0,1,1-.223-.114A.177.177,0,0,1,532.783,433.349Z",
    transform: "translate(-526.59 -421.95)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(3.819 9.195)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M517.351,430.112a.177.177,0,1,1-.223-.113A.177.177,0,0,1,517.351,430.112Z",
    transform: "translate(-513.503 -419.204)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(0.657 7.588)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(0 6.138)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M505.148,375.694a.177.177,0,1,1-.223-.113A.177.177,0,0,1,505.148,375.694Z",
    transform: "translate(-503.154 -373.056)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(5.886)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M519.977,368.837a.177.177,0,1,1-.223-.114A.177.177,0,0,1,519.977,368.837Z",
    transform: "translate(-515.73 -367.241)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(4.41 3.608)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(2.026 5.666)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(8.774 8.887)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M560.146,389.877a.177.177,0,1,1-.223-.114A.177.177,0,0,1,560.146,389.877Z",
    transform: "translate(-549.794 -385.084)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M547.962,371.2a.177.177,0,1,1-.223-.113A.177.177,0,0,1,547.962,371.2Z",
    transform: "translate(-539.462 -369.249)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(7.788 2.613)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 0.177,
    cy: 0.177,
    r: 0.177,
    transform: "translate(6.709 7.699)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597",
    transform: "translate(1.12 1.361)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(8.391 0.764) rotate(-61.046)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M541.128,360.306a.236.236,0,1,1-.3-.151A.236.236,0,0,1,541.128,360.306Z",
    transform: "translate(-534.111 -360.143)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(1.736 0.892)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "matrix(0.651, -0.759, 0.759, 0.651, 10.996, 3.511)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M573.945,400.277a.236.236,0,1,1-.3-.151A.235.235,0,0,1,573.945,400.277Z",
    transform: "translate(-561.941 -394.04)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(1.192 9.111) rotate(-49.492)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 0.236,
    cy: 0.236,
    r: 0.236,
    transform: "translate(0 4.12)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(0.169 0.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(3.61 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 4.444,
    height: 0.018,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 0, 0.801)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599",
    transform: "translate(7.978 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 0.018,
    height: 4.265,
    transform: "translate(0 0.016) rotate(-62.229)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(11.749 1.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 0.018,
    height: 4.379,
    transform: "translate(0 0.008) rotate(-28.397)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(13.101 5.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 4.28,
    height: 0.018,
    transform: "translate(0 4.217) rotate(-80.188)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    transform: "translate(10.071 10.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 4.312,
    height: 0.018,
    transform: "matrix(0.703, -0.711, 0.711, 0.703, 0, 3.066)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(5.861 13.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 4.269,
    height: 0.018,
    transform: "matrix(0.987, -0.158, 0.158, 0.987, 0, 0.676)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(1.915 11.696)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 0.018,
    height: 4.47,
    transform: "translate(0 0.016) rotate(-61.914)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(0.002 8.022)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 0.018,
    height: 4.144,
    transform: "translate(0 0.008) rotate(-27.432)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(0 3.791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 4.286,
    height: 0.018,
    transform: "matrix(0.157, -0.988, 0.988, 0.157, 0, 4.234)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(0.674 0.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 4.182,
    height: 0.018,
    transform: "matrix(0.701, -0.713, 0.713, 0.701, 0, 2.984)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(6.927 6.817)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 0.018,
    height: 1.994,
    transform: "translate(0 0.003) rotate(-10.365)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(4.044 6.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 2.925,
    height: 0.018,
    transform: "translate(0 0.444) rotate(-8.724)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(4.042 7.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 0.018,
    height: 3.586,
    transform: "translate(0 0.016) rotate(-64.96)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(6.084 8.775)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 1.976,
    height: 0.018,
    transform: "matrix(0.609, -0.793, 0.793, 0.609, 0, 1.568)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(6.09 9.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 3.291,
    height: 0.018,
    transform: "translate(0 0.38) rotate(-6.637)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(7.29 8.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 0.018,
    height: 2.382,
    transform: "matrix(0.498, -0.867, 0.867, 0.498, 0, 0.015)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(7.462 8.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 2.126,
    height: 0.018,
    transform: "translate(0 0.132) rotate(-3.569)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(9.576 8.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 0.018,
    height: 2.865,
    transform: "matrix(0.851, -0.525, 0.525, 0.851, 0, 0.009)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    transform: "translate(11.084 10.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 2.24,
    height: 0.018,
    transform: "translate(0 0.965) rotate(-25.514)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(10.069 11.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 2.331,
    height: 0.018,
    transform: "translate(0 2.1) rotate(-64.269)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(8.698 12.53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 0.018,
    height: 1.499,
    transform: "translate(0 0.016) rotate(-66.665)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(6.433 12.349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 0.018,
    height: 2.274,
    transform: "matrix(0.079, -0.997, 0.997, 0.079, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    transform: "translate(5.854 12.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 1.559,
    height: 0.018,
    transform: "matrix(0.367, -0.93, 0.93, 0.367, 0, 1.45)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(4.082 11.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 0.018,
    height: 2.63,
    transform: "translate(0 0.012) rotate(-42.401)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    transform: "translate(4.08 10.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 1.621,
    height: 0.018,
    transform: "translate(0 1.59) rotate(-78.787)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(4.404 10.267)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 0.018,
    height: 1.688,
    transform: "translate(0 0.018) rotate(-87.559)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(4.035 7.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 0.018,
    height: 3.035,
    transform: "translate(0 0.002) rotate(-6.848)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(1.239 7.254)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 3.136,
    height: 0.018,
    transform: "translate(0 1.407) rotate(-26.653)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(0.006 8.018)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 0.018,
    height: 1.391,
    transform: "matrix(0.463, -0.887, 0.887, 0.463, 0, 0.016)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(0.003 7.214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 0.991,
    height: 0.018,
    transform: "translate(0 0.807) rotate(-54.5)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    transform: "translate(0.584 6.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 2.08,
    height: 0.018,
    transform: "translate(0 0.472) rotate(-13.124)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    transform: "translate(2.225 3.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 0.018,
    height: 3.173,
    transform: "translate(0 0.002) rotate(-6.855)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(0.678 3.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 1.567,
    height: 0.018,
    transform: "translate(0 0.195) rotate(-7.162)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(2.231 2.546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 2.483,
    height: 0.018,
    transform: "matrix(0.907, -0.42, 0.42, 0.907, 0, 1.043)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(2.226 0.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 3.109,
    height: 0.018,
    transform: "translate(0 2.787) rotate(-63.712)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(6.934 5.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 3.808,
    height: 0.018,
    transform: "translate(0 1.067) rotate(-16.274)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(10.592 5.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 0.018,
    height: 3.248,
    transform: "translate(0 0.018) rotate(-88.302)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    transform: "translate(8.692 9.965)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 2.654,
    height: 0.018,
    transform: "matrix(0.248, -0.969, 0.969, 0.248, 0, 2.571)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(9.35 8.592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 1.393,
    height: 0.018,
    transform: "translate(0 1.374) rotate(-80.686)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(9.576 5.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 3.015,
    height: 0.018,
    transform: "matrix(0.334, -0.942, 0.942, 0.334, 0, 2.841)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638",
    transform: "translate(10.374 4.344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 0.018,
    height: 1.422,
    transform: "translate(0 0.003) rotate(-8.446)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639",
    transform: "translate(10.374 1.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 2.721,
    height: 0.018,
    transform: "matrix(0.506, -0.863, 0.863, 0.506, 0, 2.348)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640",
    transform: "translate(8.738 1.988)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 3.153,
    height: 0.018,
    transform: "matrix(0.957, -0.291, 0.291, 0.957, 0, 0.918)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(6.502 2.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 2.244,
    height: 0.018,
    transform: "translate(0 0.169) rotate(-4.329)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(4.486 2.546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 0.018,
    height: 2.083,
    transform: "matrix(0.254, -0.967, 0.967, 0.254, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643",
    transform: "translate(3.603 0.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 0.018,
    height: 1.953,
    transform: "matrix(0.894, -0.449, 0.449, 0.894, 0, 0.008)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644",
    transform: "translate(4.483 1.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 2.471,
    height: 0.018,
    transform: "translate(0 1.474) rotate(-36.63)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(6.467 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 1.852,
    height: 0.018,
    transform: "matrix(0.815, -0.579, 0.579, 0.815, 0, 1.073)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(7.974 0.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 0.018,
    height: 3.003,
    transform: "translate(0 0.005) rotate(-14.639)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647",
    transform: "translate(4.989 3.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 2.202,
    height: 0.018,
    transform: "translate(0 1.605) rotate(-46.795)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(4.037 4.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 2.744,
    height: 0.018,
    transform: "translate(0 2.574) rotate(-69.737)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    transform: "translate(2.608 6.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 0.018,
    height: 1.524,
    transform: "translate(0 0.017) rotate(-70.206)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    transform: "translate(11.818 7.024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 1.976,
    height: 0.018,
    transform: "translate(0 1.954) rotate(-81.438)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(9.583 8.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 0.018,
    height: 2.276,
    transform: "matrix(0.17, -0.985, 0.985, 0.17, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    transform: "translate(4.989 4.683)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 0.018,
    height: 2.882,
    transform: "matrix(0.739, -0.674, 0.674, 0.739, 0, 0.012)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653",
    transform: "translate(6.494 3.083)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 0.018,
    height: 3.76,
    transform: "translate(0 0.002) rotate(-6.626)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(6.93 4.339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 4.242,
    height: 0.018,
    transform: "translate(0 2.471) rotate(-35.62)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(6.929 2.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 4.301,
    height: 0.018,
    transform: "translate(0 3.905) rotate(-65.215)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656",
    transform: "translate(12.117 5.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 2.082,
    height: 0.018,
    transform: "translate(0 1.178) rotate(-34.456)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(12.113 7.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 0.018,
    height: 3.196,
    transform: "translate(0 0.006) rotate(-18.003)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(11.821 8.973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 0.018,
    height: 1.68,
    transform: "matrix(0.646, -0.763, 0.763, 0.646, 0, 0.014)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(11.08 8.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 2.181,
    height: 0.018,
    transform: "translate(0 2.052) rotate(-70.212)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(8.696 11.024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 2.823,
    height: 0.018,
    transform: "translate(0 1.506) rotate(-32.251)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(4.087 11.857)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 0.018,
    height: 2.396,
    transform: "matrix(0.205, -0.979, 0.979, 0.205, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(1.918 11.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 0.018,
    height: 2.176,
    transform: "translate(0 0.018) rotate(-85.718)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(1.235 8.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 0.018,
    height: 3.109,
    transform: "translate(0 0.004) rotate(-12.506)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(1.236 8.663)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 0.018,
    height: 4.28,
    transform: "matrix(0.747, -0.665, 0.665, 0.747, 0, 0.012)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(0.577 7.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 0.018,
    height: 1.592,
    transform: "translate(0 0.007) rotate(-24.376)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(0.577 3.792)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 3.428,
    height: 0.018,
    transform: "translate(0 3.427) rotate(-88.431)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    transform: "translate(3.61 0.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 0.018,
    height: 2.873,
    transform: "matrix(0.094, -0.996, 0.996, 0.094, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668",
    transform: "translate(6.082 10.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 0.018,
    height: 2.039,
    transform: "matrix(0.986, -0.168, 0.168, 0.986, 0, 0.003)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(6.428 9.961)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 3.778,
    height: 0.018,
    transform: "translate(0 2.39) rotate(-39.254)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670",
    transform: "translate(10.586 5.745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 0.018,
    height: 1.991,
    transform: "matrix(0.64, -0.768, 0.768, 0.64, 0, 0.014)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671",
    transform: "translate(8.735 2.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 0.018,
    height: 2.178,
    transform: "translate(0 0.013) rotate(-48.933)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    transform: "translate(6.463 1.081)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 0.018,
    height: 2.003,
    transform: "translate(0 0) rotate(-0.892)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(4.48 2.552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 0.018,
    height: 2.194,
    transform: "translate(0 0.004) rotate(-13.356)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    transform: "translate(2.606 4.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 3.149,
    height: 0.018,
    transform: "matrix(0.757, -0.654, 0.654, 0.757, 0, 2.058)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(2.231 3.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 0.018,
    height: 2.969,
    transform: "translate(0 0.017) rotate(-68.418)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676",
    transform: "translate(1.179 3.592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 2.112,
    height: 0.018,
    transform: "translate(0 1.834) rotate(-60.272)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(1.179 5.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 0.018,
    height: 3.239,
    transform: "translate(0 0) rotate(-0.963)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(2.469 7.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 3.295,
    height: 0.018,
    transform: "translate(0 2.898) rotate(-61.576)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679",
    transform: "translate(9.662 1.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 0.018,
    height: 2.109,
    transform: "matrix(0.118, -0.993, 0.993, 0.118, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    transform: "translate(7.742 1.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 0.018,
    height: 1.968,
    transform: "translate(0 0.017) rotate(-77.193)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(6.47 1.072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 0.018,
    height: 1.292,
    transform: "matrix(0.178, -0.984, 0.984, 0.178, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682",
    transform: "translate(9.656 1.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 0.018,
    height: 3.843,
    transform: "matrix(0.732, -0.681, 0.681, 0.732, 0, 0.012)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683",
    transform: "translate(12.274 4.554)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 0.018,
    height: 2.022,
    transform: "translate(0 0.014) rotate(-50.452)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684",
    transform: "translate(12.272 4.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 0.018,
    height: 2.86,
    transform: "translate(0 0.003) rotate(-9.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1685",
    "data-name": "Group 1685",
    transform: "translate(12.723 7.384)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 0.018,
    height: 2.707,
    transform: "matrix(0.99, -0.139, 0.139, 0.99, 0, 0.002)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686",
    transform: "translate(11.819 7.381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 1.833,
    height: 0.018,
    transform: "translate(0 1.595) rotate(-60.469)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1687",
    "data-name": "Group 1687",
    transform: "translate(6.432 11.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 4.839,
    height: 0.018,
    transform: "translate(0 1.326) rotate(-15.906)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1688",
    "data-name": "Group 1688",
    transform: "translate(1.911 10.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 1.641,
    height: 0.018,
    transform: "translate(0 1.544) rotate(-70.178)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689",
    transform: "translate(0.671 3.789)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 0.018,
    height: 1.715,
    transform: "translate(0 0.005) rotate(-17.216)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1690",
    "data-name": "Group 1690",
    transform: "translate(2.952 1.072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 3.698,
    height: 0.018,
    transform: "translate(0 1.143) rotate(-18)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1691",
    "data-name": "Group 1691",
    transform: "translate(5.859 12.53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 3.11,
    height: 0.018,
    transform: "translate(0 1.27) rotate(-24.113)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692",
    transform: "translate(2.475 10.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 0.018,
    height: 1.932,
    transform: "translate(0 0.018) rotate(-86.551)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1693",
    "data-name": "Group 1693",
    transform: "translate(1.235 6.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 2.36,
    height: 0.018,
    transform: "matrix(0.58, -0.815, 0.815, 0.58, 0, 1.922)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1694",
    "data-name": "Group 1694",
    transform: "translate(6.495 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 2.164,
    height: 0.018,
    transform: "translate(0 1.772) rotate(-54.981)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695",
    transform: "translate(6.932 6.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 0.018,
    height: 3.187,
    transform: "matrix(0.557, -0.831, 0.831, 0.557, 0, 0.015)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696",
    transform: "translate(4.399 6.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 4.285,
    height: 0.018,
    transform: "translate(0 3.459) rotate(-53.818)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697",
    transform: "translate(8.734 1.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 1.488,
    height: 0.018,
    transform: "matrix(0.62, -0.785, 0.785, 0.62, 0, 1.167)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698",
    transform: "translate(11.748 1.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 0.018,
    height: 2.617,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, 0, 0.004)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    transform: "translate(7.976 0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 0.018,
    height: 2.418,
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 0, 0.012)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(7.735 0.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 1.324,
    height: 0.018,
    transform: "translate(0 1.302) rotate(-79.583)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(4.398 10.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 0.018,
    height: 2.907,
    transform: "translate(0 0.012) rotate(-44.268)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    transform: "translate(1.18 5.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 0.018,
    height: 4.902,
    transform: "translate(0 0.005) rotate(-15.203)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(1.181 2.548)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 4.378,
    height: 0.018,
    transform: "translate(0 2.876) rotate(-41.059)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704",
    transform: "translate(9.355 9.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 0.018,
    height: 2.03,
    transform: "translate(0 0.015) rotate(-58.389)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705",
    transform: "translate(10.382 4.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 0.018,
    height: 1.909,
    transform: "translate(0 0.018) rotate(-83.52)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(6.5 3.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 0.018,
    height: 4.08,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(9.579 7.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 2.983,
    height: 0.018,
    transform: "matrix(0.851, -0.525, 0.525, 0.851, 0, 1.567)",
    fill: "#a4bac6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 0.238,
    cy: 0.238,
    r: 0.238,
    transform: "translate(8.475 14.572)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 0.19,
    cy: 0.19,
    r: 0.19,
    transform: "translate(4.028 13.916)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 0.314,
    cy: 0.314,
    r: 0.314,
    transform: "translate(0.6 10.361)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 0.19,
    cy: 0.19,
    r: 0.19,
    transform: "translate(0 6.128)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 0.314,
    cy: 0.314,
    r: 0.314,
    transform: "translate(1.949 1.934)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 0.19,
    cy: 0.19,
    r: 0.19,
    transform: "translate(6.027)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 0.19,
    cy: 0.19,
    r: 0.19,
    transform: "translate(13.892 3.885)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 0.438,
    cy: 0.438,
    r: 0.438,
    transform: "translate(10.474 0.381)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 0.314,
    cy: 0.314,
    r: 0.314,
    transform: "translate(14.611 8.352)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 0.19,
    cy: 0.19,
    r: 0.19,
    transform: "translate(12.606 12.509)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(0.851 1.19)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.3,
    cy: 0.3,
    r: 0.3,
    transform: "translate(6.457 5.886)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(8.605 8.606)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(4.487 9.234)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(3.393 5.892) rotate(-80.825)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(7.26 2.466) rotate(-80.825)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(10.814 4.563)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(11.756 7.916)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(10.814 9.799)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(9.389 11.635)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 0.312,
    cy: 0.312,
    r: 0.312,
    transform: "translate(6.305 12.823) rotate(-80.814)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(4.235 11.447)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(2.864 8.669)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(2.02 10.176)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(0.188 5.998)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(0 4.312)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(2.864 1.183)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(7.959 0.371) rotate(-80.288)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(5.492 0.869)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(5.303 3.2)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 0.432,
    cy: 0.432,
    r: 0.432,
    transform: "translate(1.965 4.256)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(7.959 10.33) rotate(-80.288)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(10.626 6.12)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(9.684 2.635)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(9.054 3.304)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 0.188,
    cy: 0.188,
    r: 0.188,
    transform: "translate(6.285 8.104)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(1.736 1.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(10.055 1.758)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(8.254 0.683)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(3.074)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(11.781 5.472)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(11.308 8.482)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(0 7.918)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 0.251,
    cy: 0.251,
    r: 0.251,
    transform: "translate(0.251 2.7)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824",
    transform: "translate(0.181 0.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    transform: "translate(6.035 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 0.019,
    height: 4.736,
    transform: "matrix(0.133, -0.991, 0.991, 0.133, 0, 0.019)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(10.724 0.631)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 0.019,
    height: 4.546,
    transform: "translate(0 0.013) rotate(-44.229)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(13.892 3.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 0.019,
    height: 4.667,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 0, 0.003)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717",
    transform: "translate(12.607 8.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 4.561,
    height: 0.019,
    transform: "matrix(0.467, -0.884, 0.884, 0.467, 0, 4.034)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718",
    transform: "translate(8.528 12.511)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 4.596,
    height: 0.019,
    transform: "translate(0 2.109) rotate(-27.315)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(4.036 13.916)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 0.019,
    height: 4.55,
    transform: "translate(0 0.019) rotate(-81.106)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720",
    transform: "translate(0.726 10.488)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 0.019,
    height: 4.764,
    transform: "translate(0 0.013) rotate(-43.914)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721",
    transform: "translate(0 6.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 0.019,
    height: 4.416,
    transform: "translate(0 0.003) rotate(-9.432)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722",
    transform: "translate(0 2.063)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 4.568,
    height: 0.019,
    transform: "translate(0 4.07) rotate(-62.985)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723",
    transform: "translate(2.079 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 4.457,
    height: 0.019,
    transform: "matrix(0.887, -0.462, 0.462, 0.887, 0, 2.059)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724",
    transform: "translate(7.136 7.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 2.125,
    height: 0.019,
    transform: "translate(0 2.106) rotate(-82.368)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725",
    transform: "translate(4.35 6.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 0.019,
    height: 3.118,
    transform: "matrix(0.161, -0.987, 0.987, 0.161, 0, 0.019)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    transform: "translate(4.345 6.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 0.019,
    height: 3.821,
    transform: "translate(0 0.014) rotate(-46.96)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1727",
    "data-name": "Group 1727",
    transform: "translate(5.403 9.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 2.106,
    height: 0.019,
    transform: "translate(0 1.193) rotate(-34.496)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1728",
    "data-name": "Group 1728",
    transform: "translate(5.406 10.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 0.019,
    height: 3.507,
    transform: "translate(0 0.019) rotate(-78.637)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1729",
    "data-name": "Group 1729",
    transform: "translate(7.137 9.295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 0.019,
    height: 2.539,
    transform: "translate(0 0.013) rotate(-42.103)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(7.33 9.292)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 0.019,
    height: 2.266,
    transform: "translate(0 0.018) rotate(-75.569)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731",
    transform: "translate(9.518 9.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 0.019,
    height: 3.053,
    transform: "matrix(0.972, -0.236, 0.236, 0.972, 0, 0.005)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1732",
    "data-name": "Group 1732",
    transform: "translate(10.247 12.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 2.388,
    height: 0.019,
    transform: "matrix(0.991, -0.131, 0.131, 0.991, 0, 0.312)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(8.525 12.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 2.484,
    height: 0.019,
    transform: "matrix(0.691, -0.723, 0.723, 0.691, 0, 1.795)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(7.326 13.567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 0.019,
    height: 1.598,
    transform: "translate(0 0.014) rotate(-48.665)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(5.091 12.636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 0.019,
    height: 2.424,
    transform: "matrix(0.384, -0.924, 0.924, 0.384, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736",
    transform: "translate(4.03 12.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 1.661,
    height: 0.019,
    transform: "matrix(0.637, -0.771, 0.771, 0.637, 0, 1.281)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737",
    transform: "translate(2.871 11.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 0.019,
    height: 2.803,
    transform: "translate(0 0.008) rotate(-24.401)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    "data-name": "Group 1738",
    transform: "translate(2.871 9.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 1.728,
    height: 0.019,
    transform: "translate(0 1.508) rotate(-60.782)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(3.72 9.857)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 0.019,
    height: 1.799,
    transform: "matrix(0.349, -0.937, 0.937, 0.349, 0, 0.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740",
    transform: "translate(3.715 6.691)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 3.234,
    height: 0.019,
    transform: "matrix(0.193, -0.981, 0.981, 0.193, 0, 3.173)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741",
    transform: "translate(1.046 6.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 3.342,
    height: 0.019,
    transform: "translate(0 0.503) rotate(-8.651)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742",
    transform: "translate(0.003 6.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 0.019,
    height: 1.482,
    transform: "translate(0 0.013) rotate(-44.444)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743",
    transform: "translate(0.004 5.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 1.056,
    height: 0.019,
    transform: "translate(0 0.628) rotate(-36.498)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744",
    transform: "translate(0.858 5.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 0.019,
    height: 2.217,
    transform: "translate(0 0.019) rotate(-85.124)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(3.059 2.379)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 3.381,
    height: 0.019,
    transform: "matrix(0.193, -0.981, 0.981, 0.193, 0, 3.317)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746",
    transform: "translate(2.081 2.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 0.019,
    height: 1.67,
    transform: "translate(0 0.019) rotate(-79.161)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(3.722 2.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 2.646,
    height: 0.019,
    transform: "matrix(0.993, -0.119, 0.119, 0.993, 0, 0.315)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748",
    transform: "translate(3.716 0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 3.313,
    height: 0.019,
    transform: "matrix(0.698, -0.716, 0.716, 0.698, 0, 2.372)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(7.428 7.186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 0.019,
    height: 4.058,
    transform: "matrix(0.03, -1, 1, 0.03, 0, 0.019)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750",
    transform: "translate(11.481 7.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 0.019,
    height: 3.462,
    transform: "translate(0 0.018) rotate(-70.302)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(7.325 11.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 2.828,
    height: 0.019,
    transform: "matrix(0.535, -0.845, 0.845, 0.535, 0, 2.389)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(8.838 9.862)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 1.484,
    height: 0.019,
    transform: "translate(0 1.319) rotate(-62.689)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(9.519 7.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 3.213,
    height: 0.019,
    transform: "translate(0 2.548) rotate(-52.46)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(11.475 5.822)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 1.515,
    height: 0.019,
    transform: "matrix(0.166, -0.986, 0.986, 0.166, 0, 1.494)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755",
    transform: "translate(11.729 3.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 2.9,
    height: 0.019,
    transform: "translate(0 1.927) rotate(-41.637)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756",
    transform: "translate(10.542 3.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 0.019,
    height: 3.36,
    transform: "matrix(0.019, -1, 1, 0.019, 0, 0.019)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    transform: "translate(8.216 3.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 0.019,
    height: 2.392,
    transform: "translate(0 0.018) rotate(-76.329)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(6.345 2.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 0.019,
    height: 2.22,
    transform: "matrix(0.54, -0.841, 0.841, 0.54, 0, 0.016)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(6.027 0.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 0.019,
    height: 2.081,
    transform: "translate(0 0.003) rotate(-8.679)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(6.348 1.217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 2.634,
    height: 0.019,
    transform: "translate(0 0.841) rotate(-18.631)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(8.844 0.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 1.974,
    height: 0.019,
    transform: "translate(0 0.59) rotate(-17.393)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(10.533 0.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 3.2,
    height: 0.019,
    transform: "translate(0 3.195) rotate(-86.641)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763",
    transform: "translate(6.157 3.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 2.347,
    height: 0.019,
    transform: "translate(0 1.13) rotate(-28.795)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    transform: "translate(4.344 4.391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 2.924,
    height: 0.019,
    transform: "translate(0 2.296) rotate(-51.743)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765",
    transform: "translate(3.062 5.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 0.019,
    height: 1.624,
    transform: "matrix(0.613, -0.79, 0.79, 0.613, 0, 0.015)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    "data-name": "Group 1766",
    transform: "translate(11.665 9.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 2.106,
    height: 0.019,
    transform: "translate(0 1.884) rotate(-63.435)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767",
    transform: "translate(9.522 9.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 0.019,
    height: 2.426,
    transform: "translate(0 0.017) rotate(-62.219)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768",
    transform: "translate(6.153 4.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 0.019,
    height: 3.071,
    transform: "translate(0 0.008) rotate(-24.34)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769",
    transform: "translate(7.418 3.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 4.008,
    height: 0.019,
    transform: "translate(0 3.929) rotate(-78.623)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770",
    transform: "translate(7.424 5.816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 4.521,
    height: 0.019,
    transform: "translate(0 1.369) rotate(-17.62)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1771",
    "data-name": "Group 1771",
    transform: "translate(7.421 3.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 4.584,
    height: 0.019,
    transform: "translate(0 3.364) rotate(-47.216)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772",
    transform: "translate(12.613 8.476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 2.219,
    height: 0.019,
    transform: "translate(0 0.629) rotate(-16.453)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773",
    transform: "translate(12.606 9.113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 0.019,
    height: 3.406,
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774",
    transform: "translate(11.665 10.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 0.019,
    height: 1.79,
    transform: "matrix(0.85, -0.526, 0.526, 0.85, 0, 0.01)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775",
    transform: "translate(10.241 10.991)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 2.324,
    height: 0.019,
    transform: "translate(0 1.837) rotate(-52.211)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(7.33 12.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 3.008,
    height: 0.019,
    transform: "translate(0 0.741) rotate(-14.253)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(2.874 11.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 0.019,
    height: 2.554,
    transform: "translate(0 0.017) rotate(-60.154)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778",
    transform: "translate(0.73 10.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 0.019,
    height: 2.319,
    transform: "translate(0 0.018) rotate(-67.718)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779",
    transform: "translate(0.722 7.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 3.313,
    height: 0.019,
    transform: "translate(0 3.298) rotate(-84.51)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1780",
    "data-name": "Group 1780",
    transform: "translate(1.038 7.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 0.019,
    height: 4.562,
    transform: "translate(0 0.008) rotate(-23.678)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781",
    transform: "translate(0.849 5.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 0.019,
    height: 1.697,
    transform: "matrix(0.994, -0.111, 0.111, 0.994, 0, 0.002)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782",
    transform: "translate(0.85 2.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 3.654,
    height: 0.019,
    transform: "translate(0 3.443) rotate(-70.433)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783",
    transform: "translate(6.033 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 0.019,
    height: 3.062,
    transform: "translate(0 0.017) rotate(-66.58)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1784",
    "data-name": "Group 1784",
    transform: "translate(5.085 10.493)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 2.173,
    height: 0.019,
    transform: "translate(0 2.15) rotate(-81.687)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1785",
    "data-name": "Group 1785",
    transform: "translate(5.091 11.176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 4.026,
    height: 0.019,
    transform: "translate(0 1.459) rotate(-21.254)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786",
    transform: "translate(11.476 7.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 0.019,
    height: 2.121,
    transform: "translate(0 0.01) rotate(-32.206)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(10.534 3.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 0.019,
    height: 2.322,
    transform: "translate(0 0.01) rotate(-30.933)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788",
    transform: "translate(8.209 1.224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 2.135,
    height: 0.019,
    transform: "matrix(0.294, -0.956, 0.956, 0.294, 0, 2.04)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789",
    transform: "translate(6.152 2.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 2.338,
    height: 0.019,
    transform: "matrix(0.081, -0.997, 0.997, 0.081, 0, 2.33)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    "data-name": "Group 1790",
    transform: "translate(3.064 4.388)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 3.357,
    height: 0.019,
    transform: "translate(0 1.301) rotate(-22.811)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791",
    transform: "translate(3.717 2.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 0.019,
    height: 3.165,
    transform: "matrix(0.637, -0.771, 0.771, 0.637, 0, 0.015)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792",
    transform: "translate(2.051 2.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 2.251,
    height: 0.019,
    transform: "matrix(0.74, -0.673, 0.673, 0.74, 0, 1.514)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793",
    transform: "translate(1.038 3.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 3.452,
    height: 0.019,
    transform: "translate(0 3.301) rotate(-72.964)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794",
    transform: "translate(1.8 6.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 3.512,
    height: 0.019,
    transform: "matrix(0.724, -0.689, 0.689, 0.724, 0, 2.421)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1795",
    "data-name": "Group 1795",
    transform: "translate(11.857 2.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 0.019,
    height: 2.247,
    transform: "matrix(0.419, -0.908, 0.908, 0.419, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796",
    transform: "translate(10.055 1.87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 0.019,
    height: 2.098,
    transform: "translate(0 0.016) rotate(-59.193)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    "data-name": "Group 1797",
    transform: "translate(8.842 1.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 0.019,
    height: 1.377,
    transform: "matrix(0.473, -0.881, 0.881, 0.473, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    "data-name": "Group 1798",
    transform: "translate(11.853 2.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 0.019,
    height: 4.096,
    transform: "translate(0 0.008) rotate(-24.928)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1799",
    "data-name": "Group 1799",
    transform: "translate(13.58 6.662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 0.019,
    height: 2.155,
    transform: "translate(0 0.01) rotate(-32.452)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1800",
    "data-name": "Group 1800",
    transform: "translate(13.104 6.665)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 3.048,
    height: 0.019,
    transform: "translate(0 3.011) rotate(-81.018)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801",
    transform: "translate(12.604 9.676)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 2.885,
    height: 0.019,
    transform: "translate(0 2.841) rotate(-79.985)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    transform: "translate(11.667 9.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 1.954,
    height: 0.019,
    transform: "matrix(0.738, -0.675, 0.675, 0.738, 0, 1.319)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(5.094 12.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 0.019,
    height: 5.157,
    transform: "matrix(0.037, -0.999, 0.999, 0.037, 0, 0.019)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(0.726 9.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 1.749,
    height: 0.019,
    transform: "matrix(0.613, -0.79, 0.79, 0.613, 0, 1.382)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(2.048 2.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 1.828,
    height: 0.019,
    transform: "translate(0 1.828) rotate(-89.215)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806",
    transform: "translate(4.906 1.217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 3.941,
    height: 0.019,
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    transform: "translate(4.036 13.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 3.314,
    height: 0.019,
    transform: "translate(0 0.353) rotate(-6.114)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808",
    transform: "translate(1.803 9.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 0.019,
    height: 2.059,
    transform: "translate(0 0.018) rotate(-68.551)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809",
    transform: "translate(1.041 5.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 2.515,
    height: 0.019,
    transform: "matrix(0.803, -0.595, 0.595, 0.803, 0, 1.498)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    transform: "translate(8.212 1.871)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 2.306,
    height: 0.019,
    transform: "translate(0 1.387) rotate(-36.98)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(7.42 7.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 0.019,
    height: 3.397,
    transform: "translate(0 0.012) rotate(-38.169)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812",
    transform: "translate(3.718 7.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 4.567,
    height: 0.019,
    transform: "translate(0 2.673) rotate(-35.821)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(10.537 2.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 1.585,
    height: 0.019,
    transform: "matrix(0.832, -0.555, 0.555, 0.832, 0, 0.879)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814",
    transform: "translate(13.579 3.894)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 2.79,
    height: 0.019,
    transform: "matrix(0.112, -0.994, 0.994, 0.112, 0, 2.772)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(10.722 0.633)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 0.019,
    height: 2.576,
    transform: "translate(0 0.008) rotate(-26.029)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(10.051 0.633)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 1.411,
    height: 0.019,
    transform: "translate(0 1.241) rotate(-61.577)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(3.714 9.862)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 0.019,
    height: 3.098,
    transform: "translate(0 0.008) rotate(-26.268)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818",
    transform: "translate(1.795 3.895)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 5.224,
    height: 0.019,
    transform: "translate(0 5.218) rotate(-87.203)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(2.054 2.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 4.666,
    height: 0.019,
    transform: "matrix(0.92, -0.392, 0.392, 0.92, 0, 1.827)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    transform: "translate(8.839 11.179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 0.019,
    height: 2.163,
    transform: "matrix(0.762, -0.648, 0.648, 0.762, 0, 0.012)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821",
    transform: "translate(11.732 5.815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 0.019,
    height: 2.035,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 0.017)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822",
    transform: "translate(8.213 3.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 0.019,
    height: 4.349,
    transform: "matrix(0.588, -0.809, 0.809, 0.588, 0, 0.015)",
    fill: "#a4bac6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823",
    transform: "translate(9.524 9.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 3.179,
    height: 0.019,
    transform: "translate(0 0.752) rotate(-13.685)",
    fill: "#a4bac6"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M594.442,349.159H591.66V364.2l7.468-.01.249-2.7h-4.936Z",
    transform: "translate(-557.561 -349.159)",
    fill: "#a4bac6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M647.05,349.159H644.1L640.8,359.8l-3.3-10.638h-2.964l4.776,15.042h2.963Z",
    transform: "translate(-593.92 -349.159)",
    fill: "#a4bac6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M720.018,361.5h-5.537V357.92h4.689v-2.713h-4.689V351.82l5.546-.02-.017-2.642h-8.374v15.056l8.166-.01Z",
    transform: "translate(-659.303 -349.159)",
    fill: "#a4bac6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M424.8,349.159h-2.945L418.548,359.8l-3.3-10.638h-2.964l4.776,15.042h2.963Z",
    transform: "translate(-405.445 -349.159)",
    fill: "#a4bac6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M375.651,361.5h-5.537V357.92H374.8v-2.713h-4.689V351.82l5.546-.02-.017-2.642h-8.374v15.056l8.165-.01Z",
    transform: "translate(-367.268 -349.159)",
    fill: "#a4bac6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828",
    transform: "translate(0 17.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M367.564,466.111a.3.3,0,0,1,0,.6.3.3,0,0,1-.3-.3.29.29,0,0,1,.087-.212A.284.284,0,0,1,367.564,466.111Zm-.18,1.159h.362v2.814h-.362Z",
    transform: "translate(-367.268 -466.111)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M378.856,473.332h.362v.5a1.518,1.518,0,0,1,.481-.433,1.183,1.183,0,0,1,.574-.143,1,1,0,0,1,.56.16.955.955,0,0,1,.361.432,2.284,2.284,0,0,1,.116.846v1.448h-.362V474.8a3.306,3.306,0,0,0-.04-.649.713.713,0,0,0-.242-.42.728.728,0,0,0-.466-.141.893.893,0,0,0-.588.217,1.017,1.017,0,0,0-.343.538,3.742,3.742,0,0,0-.052.766v1.032h-.362Z",
    transform: "translate(-377.095 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M403.6,473.332h.362v.5a1.516,1.516,0,0,1,.481-.433,1.182,1.182,0,0,1,.574-.143,1,1,0,0,1,.56.16.954.954,0,0,1,.361.432,2.281,2.281,0,0,1,.116.846v1.448h-.362V474.8a3.3,3.3,0,0,0-.04-.649.713.713,0,0,0-.241-.42.73.73,0,0,0-.466-.141.893.893,0,0,0-.588.217,1.018,1.018,0,0,0-.343.538,3.75,3.75,0,0,0-.052.766v1.032H403.6Z",
    transform: "translate(-398.079 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M428.911,473.26a1.394,1.394,0,0,1,1.078.471,1.511,1.511,0,0,1-.022,2.047,1.488,1.488,0,0,1-2.114,0,1.507,1.507,0,0,1-.022-2.045A1.393,1.393,0,0,1,428.911,473.26Zm0,.354a1.045,1.045,0,0,0-.776.334,1.116,1.116,0,0,0-.324.807,1.144,1.144,0,0,0,.148.569,1.048,1.048,0,0,0,.4.407,1.136,1.136,0,0,0,1.106,0,1.049,1.049,0,0,0,.4-.407,1.144,1.144,0,0,0,.148-.569,1.113,1.113,0,0,0-.326-.807A1.046,1.046,0,0,0,428.91,473.614Z",
    transform: "translate(-418.298 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M452.9,473.736h.385l.945,2.051.933-2.051h.388l-1.288,2.814H454.2Z",
    transform: "translate(-439.889 -472.577)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M479.555,473.332v2.814H479.2v-.484a1.546,1.546,0,0,1-.511.416,1.427,1.427,0,0,1-1.64-.293,1.453,1.453,0,0,1-.423-1.054,1.426,1.426,0,0,1,.427-1.04,1.391,1.391,0,0,1,1.027-.432,1.329,1.329,0,0,1,.627.147,1.429,1.429,0,0,1,.493.442v-.517Zm-1.447.277a1.091,1.091,0,0,0-.965.566,1.14,1.14,0,0,0,0,1.137,1.109,1.109,0,0,0,.409.422,1.07,1.07,0,0,0,.552.151,1.13,1.13,0,0,0,.563-.15,1.048,1.048,0,0,0,.409-.405,1.158,1.158,0,0,0,.144-.576,1.12,1.12,0,0,0-.322-.816A1.066,1.066,0,0,0,478.108,473.609Z",
    transform: "translate(-460.007 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M504.076,466.859h.362V467.9h.574v.313h-.574v2.5h-.362v-2.5h-.494V467.9h.494Z",
    transform: "translate(-482.867 -466.745)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M519.226,466.111a.286.286,0,0,1,.211.088.3.3,0,0,1,0,.422.3.3,0,0,1-.507-.209.29.29,0,0,1,.088-.212A.283.283,0,0,1,519.226,466.111Zm-.18,1.159h.362v2.814h-.362Z",
    transform: "translate(-495.883 -466.111)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M528.765,473.736h.385l.945,2.051.933-2.051h.388l-1.288,2.814h-.067Z",
    transform: "translate(-504.223 -472.577)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M554.926,475.213l.305.16a1.67,1.67,0,0,1-.347.476,1.381,1.381,0,0,1-.443.275,1.545,1.545,0,0,1-.557.094,1.346,1.346,0,0,1-1.077-.451,1.524,1.524,0,0,1-.388-1.02,1.505,1.505,0,0,1,.329-.955,1.345,1.345,0,0,1,1.116-.533,1.389,1.389,0,0,1,1.149.546,1.526,1.526,0,0,1,.311.962h-2.532a1.144,1.144,0,0,0,.313.8,1,1,0,0,0,.748.313,1.207,1.207,0,0,0,.418-.075,1.1,1.1,0,0,0,.346-.2A1.686,1.686,0,0,0,554.926,475.213Zm0-.758a1.2,1.2,0,0,0-.211-.463,1,1,0,0,0-.367-.279,1.125,1.125,0,0,0-.479-.106,1.031,1.031,0,0,0-.712.267,1.2,1.2,0,0,0-.329.582Z",
    transform: "translate(-524.284 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M602.173,473.64l-.233.241a.837.837,0,0,0-.568-.282.429.429,0,0,0-.3.116.359.359,0,0,0-.126.272.4.4,0,0,0,.1.261,1.458,1.458,0,0,0,.435.3,1.625,1.625,0,0,1,.55.4.736.736,0,0,1,.143.442.794.794,0,0,1-.244.587.831.831,0,0,1-.609.241,1.062,1.062,0,0,1-.465-.106,1.01,1.01,0,0,1-.367-.292l.228-.259a.791.791,0,0,0,.589.313.531.531,0,0,0,.371-.14.432.432,0,0,0,.153-.329.421.421,0,0,0-.1-.277,1.631,1.631,0,0,0-.456-.3,1.46,1.46,0,0,1-.518-.388.731.731,0,0,1-.138-.437.711.711,0,0,1,.219-.533.762.762,0,0,1,.553-.212A1.146,1.146,0,0,1,602.173,473.64Z",
    transform: "translate(-565.05 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M619.828,473.26a1.394,1.394,0,0,1,1.078.471,1.511,1.511,0,0,1-.022,2.047,1.488,1.488,0,0,1-2.114,0,1.507,1.507,0,0,1-.022-2.045A1.394,1.394,0,0,1,619.828,473.26Zm0,.354a1.044,1.044,0,0,0-.776.334,1.116,1.116,0,0,0-.325.807,1.143,1.143,0,0,0,.148.569,1.047,1.047,0,0,0,.4.407,1.136,1.136,0,0,0,1.106,0,1.048,1.048,0,0,0,.4-.407,1.144,1.144,0,0,0,.148-.569,1.113,1.113,0,0,0-.326-.807A1.047,1.047,0,0,0,619.827,473.614Z",
    transform: "translate(-580.202 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M645.214,466.587h.362v3.9h-.362Z",
    transform: "translate(-602.976 -466.515)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M655.729,473.736h.362v1.314a2.813,2.813,0,0,0,.052.662.738.738,0,0,0,.3.409.9.9,0,0,0,.522.15.882.882,0,0,0,.514-.146.746.746,0,0,0,.291-.384,2.709,2.709,0,0,0,.054-.691v-1.314h.37v1.381a2.182,2.182,0,0,1-.136.877,1.035,1.035,0,0,1-.409.462,1.291,1.291,0,0,1-.684.167,1.306,1.306,0,0,1-.687-.167,1.027,1.027,0,0,1-.411-.465,2.272,2.272,0,0,1-.136-.9Z",
    transform: "translate(-611.893 -472.577)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M680.032,466.859h.362V467.9h.574v.313h-.574v2.5h-.362v-2.5h-.494V467.9h.494Z",
    transform: "translate(-632.084 -466.745)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M695.183,466.111a.287.287,0,0,1,.211.088.3.3,0,0,1,0,.422.287.287,0,0,1-.211.088.284.284,0,0,1-.209-.088.3.3,0,0,1,0-.422A.284.284,0,0,1,695.183,466.111ZM695,467.27h.362v2.814H695Z",
    transform: "translate(-645.101 -466.111)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M707.041,473.26a1.394,1.394,0,0,1,1.078.471,1.511,1.511,0,0,1-.022,2.047,1.488,1.488,0,0,1-2.114,0,1.507,1.507,0,0,1-.022-2.045A1.393,1.393,0,0,1,707.041,473.26Zm0,.354a1.044,1.044,0,0,0-.776.334,1.115,1.115,0,0,0-.324.807,1.144,1.144,0,0,0,.148.569,1.049,1.049,0,0,0,.4.407,1.136,1.136,0,0,0,1.106,0,1.05,1.05,0,0,0,.4-.407,1.143,1.143,0,0,0,.148-.569,1.113,1.113,0,0,0-.326-.807A1.045,1.045,0,0,0,707.04,473.614Z",
    transform: "translate(-654.162 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M732.784,473.332h.362v.5a1.516,1.516,0,0,1,.481-.433,1.182,1.182,0,0,1,.574-.143,1,1,0,0,1,.56.16.955.955,0,0,1,.361.432,2.286,2.286,0,0,1,.116.846v1.448h-.362V474.8a3.317,3.317,0,0,0-.04-.649.713.713,0,0,0-.242-.42.729.729,0,0,0-.466-.141.894.894,0,0,0-.589.217,1.016,1.016,0,0,0-.343.538,3.745,3.745,0,0,0-.052.766v1.032h-.362Z",
    transform: "translate(-677.239 -472.174)",
    fill: "#a4bac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M757.457,473.64l-.233.241a.837.837,0,0,0-.568-.282.429.429,0,0,0-.3.116.359.359,0,0,0-.126.272.4.4,0,0,0,.1.261,1.451,1.451,0,0,0,.435.3,1.624,1.624,0,0,1,.55.4.735.735,0,0,1,.143.442.793.793,0,0,1-.244.587.831.831,0,0,1-.609.241,1.063,1.063,0,0,1-.465-.106,1.01,1.01,0,0,1-.367-.292l.228-.259a.791.791,0,0,0,.588.313.53.53,0,0,0,.371-.14.432.432,0,0,0,.153-.329.422.422,0,0,0-.1-.277,1.632,1.632,0,0,0-.456-.3,1.457,1.457,0,0,1-.519-.388A.731.731,0,0,1,755.9,474a.711.711,0,0,1,.219-.533.763.763,0,0,1,.553-.212A1.147,1.147,0,0,1,757.457,473.64Z",
    transform: "translate(-696.736 -472.174)",
    fill: "#a4bac6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolveLogo);
export default __webpack_public_path__ + "static/media/evolve-logo.8171bbabb2942a01b5702f46d05963aa.svg";
export { ForwardRef as ReactComponent };